"use strict";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const accordions = document.querySelectorAll(".o-accordion");

        if (!accordions.length) return;

        accordions.forEach((accordion, index) => {
            const header = accordion.querySelector(".o-accordion__header");
            const content = accordion.querySelector(".o-accordion__content");

            // Apenas o primeiro começa aberto
            if (index === 0) {
                header.setAttribute("aria-expanded", "true");
                content.hidden = false;
            } else {
                header.setAttribute("aria-expanded", "false");
                content.hidden = true;
            }

            header.addEventListener("click", () => {
                const isExpanded =
                    header.getAttribute("aria-expanded") === "true";

                // Fecha todos os outros
                accordions.forEach((acc) => {
                    const otherHeader = acc.querySelector(
                        ".o-accordion__header"
                    );
                    const otherContent = acc.querySelector(
                        ".o-accordion__content"
                    );
                    otherHeader.setAttribute("aria-expanded", "false");
                    otherContent.hidden = true;
                });

                // Abre o atual se estava fechado
                if (!isExpanded) {
                    header.setAttribute("aria-expanded", "true");
                    content.hidden = false;
                }
            });
        });
    });
}
